<template>
  <div class="mb-6">
    <vs-card>
      <div class="filtroConsolidado vx-row px-2 py-1 mb-3">
        <div class="vx-col lg:w-1/4 w-full">
          <span class="labelFiltro">Razão Social</span>
          <div class="vx-col sm:flex gap-4 w-full mt-2">
            <div class="vx-col relative flex gap-4 w-full">
              <vs-input
                icon="search"
                placeholder="Razão Social"
                v-model="form.name"
                class="w-full sm:mb-0 mb-3"
              />
            </div>
          </div>
        </div>
        <div class="vx-col lg:w-1/4 w-full">
          <span class="labelFiltro">CNPJ/CPF</span>
          <div class="vx-col sm:flex gap-4 w-full mt-2">
            <div class="vx-col relative flex gap-4 w-full">
              <vs-input
                icon="search"
                placeholder="CNPJ/CPF"
                v-model="form.cnpj"
                class="w-full sm:mb-0 mb-3"
                v-mask="['###.###.###-##', '##.###.###/####-##']"
              />
            </div>
          </div>
        </div>
        <div class="vx-col lg:w-1/4 w-full">
          <span class="labelFiltro">Assessorias</span>
          <div class="vx-col sm:flex gap-4 w-full mt-2">
            <div class="vx-col relative flex gap-4 w-full">
              <v-selectsubjectPer
                class="w-full mb-3"
                :options="consultanciesOptions"
                icon="search"
                name="Assessorias"
                id="Assessorias"
                placeholder="Assessorias"
                v-model="form.consultancies"
                multiple
                :reduce="(option) => option.value"
                :closeOnSelect="false"
              />
            </div>
          </div>
        </div>
        <div class="vx-col lg:w-1/4 w-full">
          <span class="labelFiltro">Convênios</span>
          <div class="vx-col sm:flex gap-4 w-full mt-2">
            <div class="vx-col relative flex gap-4 w-full">
              <v-select
                class="w-full mb-3"
                :options="covenantsOptions"
                icon="search"
                name="Convênios"
                id="Convênios"
                placeholder="Convênios"
                v-model="form.covenants"
                multiple
                :reduce="(option) => option.value"
                :closeOnSelect="false"
              />
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <br style="clear: both" />
        <vs-row class="flex items-end justify-end p-1">
          <div class="bg-white mr-3 mb-2">
            <vs-button
              v-if="$can($actionsDefault.Exportar, subjectPermission)"
              color="success"
              type="border"
              icon-pack="feather"
              icon="icon-download"
              icon-after
              @click="exportXls"
            >
              Exportar
            </vs-button>
          </div>
          <vs-button
            data-testId="search-button"
            color="success"
            type="filled"
            icon-pack="feather"
            icon="icon-search"
            class="mr-3 mb-2"
            @click="submit"
            >Buscar
          </vs-button>
          <vs-button
            data-testId="clear-button"
            @click="reset"
            color="danger"
            type="gradient"
            icon-pack="feather"
            class="mb-2"
            icon="icon-trash-2"
          ></vs-button>
        </vs-row>
      </div>
    </vs-card>
  </div>
</template>

<script>
import reportsApi from '@/services/reports.api';
import vSelect from 'vue-select';

export default {
  name: 'BrokersFilter',
  components: {
    'v-select': vSelect,
  },
  props: {
    subjectPermission: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      companyId: 118,
      consultanciesOptions: [],
      covenantsOptions: [],
      form: this.getDefaultForm(),
    };
  },
  created() {
    this.getConsultanciesOptions();
    this.getCovenantOptions();
  },
  methods: {
    getDefaultForm() {
      return {
        consultancies: [],
        covenants: [],
        cnpj: '',
        name: '',
      };
    },
    reset() {
      this.form = this.getDefaultForm();
      this.$emit('submit', this.form);
    },
    submit() {
      this.$emit('submit', this.form);
    },
    exportXls() {
      this.$emit('export', this.form);
    },
    getConsultanciesOptions() {
      reportsApi.getCompanyConsultancies(this.companyId).then((response) => {
        this.consultanciesOptions = response.map((consultancy) => ({
          label: consultancy.divisionName,
          value: consultancy.id,
        }));
      });
    },
    getCovenantOptions() {
      reportsApi.getCompanyCovenants(this.companyId).then((response) => {
        this.covenantsOptions = response.map((consultancy) => ({
          label: consultancy.name,
          value: consultancy.id,
        }));
      });
    },
  },
};
</script>

<style scoped></style>
